import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Nullable } from "../../../../Types/Common";
import { SLICE_NAMES } from "../../../../constants/action";
import { IDepartmentTaskList, IInitialDepartmentState } from "../../types";

const initialState: IInitialDepartmentState = {
  selectDepartment: 1,
  departmentCategoryPage: 1,
  departmentCategoryPageSize: 200,
  departmentCategoryTotalRows: 0,
  departmentCategoryPerPage: 0,
  departmentCategoryTable: null,
  editDepartmentCategoryDetails: null,
  deleteDepartmentCategoryDetails: null,
};

const reducers = {
  setDepartmentCategoryTable: (
    state: IInitialDepartmentState,
    action: PayloadAction<IDepartmentTaskList[]>
  ) => {
    state.departmentCategoryTable = action.payload;
  },
  setEditDepartmentCategory: (
    state: IInitialDepartmentState,
    action: PayloadAction<Nullable<IDepartmentTaskList>>
  ) => {
    state.editDepartmentCategoryDetails = action.payload;
  },
  setSelectDepartment: (
    state: IInitialDepartmentState,
    action: PayloadAction<Nullable<number>>
  ) => {
    state.selectDepartment = action.payload;
  },
  setDeleteDepartmentCategoryDetails: (
    state: IInitialDepartmentState,
    action: PayloadAction<Nullable<IDepartmentTaskList>>
  ) => {
    state.deleteDepartmentCategoryDetails = action.payload;
  },

  setDepartmentCategoryPage: (
    state: IInitialDepartmentState,
    action: PayloadAction<number>
  ) => {
    state.departmentCategoryPage = action.payload;
  },

  setDepartmentCategoryPageSize: (
    state: IInitialDepartmentState,
    action: PayloadAction<number>
  ) => {
    state.departmentCategoryPageSize = action.payload;
  },

  setDepartmentCategoryTotalRows: (
    state: IInitialDepartmentState,
    action: PayloadAction<number>
  ) => {
    state.departmentCategoryTotalRows = action.payload;
  },

  setDepartmentCategoryPerPage: (
    state: IInitialDepartmentState,
    action: PayloadAction<number>
  ) => {
    state.departmentCategoryPerPage = action.payload;
  },
};

const departmentCategoryStateSlice = createSlice({
  name: SLICE_NAMES.DEPARTMENT_CATEGORY_STATES,
  initialState,
  reducers,
});

export const {
  setSelectDepartment,
  setDepartmentCategoryPage,
  setEditDepartmentCategory,
  setDepartmentCategoryTable,
  setDepartmentCategoryPerPage,
  setDepartmentCategoryPageSize,
  setDepartmentCategoryTotalRows,
  setDeleteDepartmentCategoryDetails,
} = departmentCategoryStateSlice.actions;

export default departmentCategoryStateSlice.reducer;
